export const LD_FF_URL_BASE =
  'https://app.launchdarkly.com/order-app/sandbox/features';
